/* eslint-disable */

export const setClearValue = (data) => {
	// return birthday.replace(/\./g, '').replace(/-/g, '');
	return data?.replace(/\D/g, '');
}

export const setClearPhone = (phone) => {
    let replacePhone = String(phone).replace(/\D+/g, "");

    let cleanPhoneNumber = replacePhone;
        if (replacePhone[0] == '7' || replacePhone[0] == '8') {
            cleanPhoneNumber = replacePhone.slice(1, 11);
        }

    return cleanPhoneNumber;
}

export const formatBirthday = (birthday) => {
    let date = String(birthday).replace(/\D+/g, "");
    let day = date.slice(0, 2);
    let month = date.slice(2, 4);
    let year = date.slice(4, 8);

    return `${year}-${month}-${day}`;
}

export const formatTime = (data, showHoursMinutes = false) => {
	const validDate = typeof data === 'string' || data instanceof Date

	if (!validDate) return 'Invalid Date'

	const originalDate = new Date(data)
	const pad = (timeItem) => timeItem.toString().padStart(2, '0')

	const day = pad(originalDate.getDate())
	const month = pad(originalDate.getMonth() + 1)
	const year = pad(originalDate.getFullYear())
	const hours = pad(originalDate.getHours())
	const minutes = pad(originalDate.getMinutes())

	if (!showHoursMinutes) {
		return `${day}.${month}.${year}`
	}

	return `${day}.${month}.${year}, ${hours}:${minutes}`
}

export const formatPhone = (v) => {
    if (v && v.length == 10) {
        return `+7 (${v[0]}${v[1]}${v[2]}) ${v[3]}${v[4]}${v[5]}-${v[6]}${v[7]}-${v[8]}${v[9]}`;
    } else {
        return v;
    }
}

export const formatNumber = val => {
	return new Intl.NumberFormat('ru-RU').format(val)
}
